<template>
  <base-island :class="$style.root">
    <div :class="$style.wrapper">
      <div :class="$style.container">
        <div :class="$style.noApplicants">
          <slot />
        </div>
      </div>
      <div
        v-if="showRequest"
        :class="$style.request"
      >
        <slot name="request" />
      </div>
    </div>
  </base-island>
</template>

<script>
import BaseIsland from '@/shared/legacy/ui/base-island/base-island.vue';

export default {
  name: 'AddApplicantContainer',
  components: { BaseIsland },
  props: {
    showRequest: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style module>
.root {
  width: 100%;
  height: 100%;
}

.wrapper {
  composes: layout__wrapper from global;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 100%;
}

.container {
  text-align: center;
  padding-bottom: 30px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.noApplicants {
  background-image: url(images/glass-2.svg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100px 100px;

  padding-top: 116px;
  color: rgba(0, 0, 0, 0.36);
  font-size: 20px;
  line-height: 26px;
}

.request {
  position: fixed;
  left: 15px;
  bottom: 75px;
  background-image: url(images/request.svg);
  background-repeat: no-repeat;
  background-position: bottom left;
  background-size: 18px 35px;
  padding-bottom: 40px;
  width: 115px;

  font-size: 11px;
  color: #ffffff;
  line-height: 16px;
  text-transform: uppercase;
}
</style>

<i18n lang="json">{}</i18n>
